exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html{height:100%}#logo{max-height:180px;max-width:100%}#footer{position:absolute;bottom:0;width:100%;padding:10px}#footer .retailer-information{text-align:right;max-width:100%;margin:10px}@media (min-width: 992px){#footer .retailer-information{max-width:400px}}\n", ""]);

